import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { ConnectedRouter, connectRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import { createStore, applyMiddleware, combineReducers } from "redux";

import rootReducer from "./redux/combineReducers";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Create browser history to use in the Redux store
// const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: undefined });

// Get the application-wide store instance, prepopulating with state from the server where available.

const globalReducer = combineReducers({
  _newReduxTree: rootReducer,
  router: connectRouter(history),
});

const newStore = createStore(globalReducer, applyMiddleware(thunk));

ReactDOM.render(
  <Provider store={newStore}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
